import styled, { css } from 'styled-components';
import { ellipsis } from '../../../../styles/mixins';

export const InputFieldLabel = styled.label<{
  focus: boolean;
  hasIconLeft: boolean;
  hasIconRight: boolean;
  isValid: boolean;
}>`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  height: 52px;
  border-radius: 8px;
  position: relative;
  background-color: ${({ theme }) => theme.kallisto.color.common.black[50]};
  padding: 0 16px;

  ${({ hasIconLeft }) =>
    hasIconLeft &&
    css`
      padding: 0 16px 0 44px;
      > img {
        position: absolute;
        left: 16.5px;
        top: 16.5px;
      }
    `}
  ${({ hasIconRight }) =>
    hasIconRight &&
    css`
      padding: 0 44px 0 44px;
      svg {
        position: absolute;
        top: 16px;
        circle,
        line {
          stroke: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
        }
      }
      svg:first-of-type {
        left: 16px;
      }
      svg:last-of-type {
        left: unset;
        right: 10px;
      }
    `}
  ${({ focus }) =>
    focus
      ? css`
          box-shadow: inset 0 0 0 1px ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
        `
      : css`
          &:hover {
            box-shadow: inset 0 0 0 3px ${({ theme }) => theme.kallisto.color.common.black[200]};
          }
        `}
  ${({ isValid }) =>
    !isValid &&
    css`
      box-shadow: 0 0 0 1px ${({ theme }) => theme.kallisto.color.common.semantic.error[400]};
    `}
`;

export const InputFieldLabelText = styled.span<{ hasValue: boolean; focus: boolean; isValid: boolean }>`
  font-style: normal;
  font-weight: normal;
  line-height: 16px;
  color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
  cursor: pointer;
  position: absolute;
  transition: all 0.2s ease-in-out;
  display: flex;

  ${({ hasValue, focus }) =>
    hasValue || focus
      ? css`
          height: 16px;
          line-height: 28px;
          white-space: nowrap;
          font-size: ${({ theme }) => theme.kallisto.font.size['150']};
        `
      : css`
          height: 52px;
          line-height: 52px;
          font-size: ${({ theme }) => theme.kallisto.font.size['175']};
        `}

  ${({ isValid }) =>
    !isValid &&
    css`
      color: ${({ theme }) => theme.kallisto.color.common.semantic.error[400]};
    `}
`;

export const Input = styled.input`
  border: none;
  background-color: transparent;
  padding: 0;
  font-size: ${({ theme }) => theme.kallisto.font.size['200']};
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  cursor: pointer;
  outline: none;
  margin-top: 24px;
  height: 20px;
  ${ellipsis};
  width: calc(100% - 56px);
`;
